import {
    createStore
} from 'vuex'
import authModule from './modules/auth'
import userModule from './modules/user'
import appModule from './modules/app'
import configurazioneModule from './modules/configurazione'
import macchineModule from './modules/macchine'
import tipiManutenzioneModule from './modules/tipiManutenzione'
import ricambiModule from './modules/ricambi'
import manutenzioniModule from './modules/manutenzioni'
import aziendeModule from "./modules/aziende.js"
import utentiAdminModule from "./modules/utentiAdmin.js"
import utentiModule from "./modules/utenti.js"
import mezziModule from "./modules/mezzi.js"
import tipiScadenzaMezzoModule from "./modules/tipiScadenzaMezzo.js"
import scadenzeMezzoModule from "./modules/scadenzeMezzo.js"
import fornitoriModule from "./modules/fornitori.js"
import tipiPagamentoModule from "./modules/tipiPagamento.js"
import pagamentiModule from "./modules/pagamenti.js"
import clientiModule from "./modules/clienti.js"
import tipiIncassoModule from "./modules/tipiIncasso.js"
import incassiModule from "./modules/incassi.js"
import miaAziendaModule from "./modules/miaAzienda.js"
import notificheModule from "./modules/notifiche.js"
import tipiDispositivoSicurezzaModule from "./modules/tipiDispositivoSicurezza.js"
import dispositiviSicurezzaModule from "./modules/dispositiviSicurezza.js"
import contenutiSicurezzaModule from "./modules/contenutiSicurezza.js"
import cambiGommeModule from "./modules/cambiGomme.js"
import annotazioniMezzoModule from "./modules/annotazioniMezzo.js"

export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        auth: authModule,
        user: userModule,
        app: appModule,
        configurazione: configurazioneModule,
        macchine: macchineModule,
        tipiManutenzione: tipiManutenzioneModule,
        ricambi: ricambiModule,
        manutenzioni: manutenzioniModule,
        aziende: aziendeModule,
        utentiAdmin: utentiAdminModule,
        utenti: utentiModule,
        mezzi: mezziModule,
        tipiScadenzaMezzo: tipiScadenzaMezzoModule,
        scadenzeMezzo: scadenzeMezzoModule,
        fornitori: fornitoriModule,
        tipiPagamento: tipiPagamentoModule,
        pagamenti: pagamentiModule,
        clienti: clientiModule,
        tipiIncasso: tipiIncassoModule,
        incassi: incassiModule,
        miaAzienda: miaAziendaModule,
        notifiche: notificheModule,
        tipiDispositivoSicurezza: tipiDispositivoSicurezzaModule,
        dispositiviSicurezza: dispositiviSicurezzaModule,
        contenutiSicurezza: contenutiSicurezzaModule,
        cambiGomme: cambiGommeModule,
        annotazioniMezzo: annotazioniMezzoModule,
    }
})